// extracted by mini-css-extract-plugin
export default {"overlay":"sw-z","bodyOpen":"tw-z","content":"uw-z","header":"vw-z","close":"ww-z","closeNoHeading":"xw-z"};